export default function useAssets() {
  return {
    from: (name: string) => R.defaultTo('', APP_ENV.prefix) + name,
  }
}
